package com.evoapps.evoshift.widget

// Browsers have no home-screen widgets.
actual fun platformShiftWidgetStore(): ShiftWidgetStore = ShiftWidgetStore { }

// No watch app for the web.
actual fun platformWatchStore(): WatchSnapshotStore = WatchSnapshotStore { }
